module.exports = __webpack_public_path__ + "static/media/logo.f4ed53d0.png";